import {Component, ContentChild, HostListener, Input, OnInit, TemplateRef} from '@angular/core';
import {debounce} from 'lodash-es'


@Component({
  selector: 'app-masonry',
  templateUrl: './masonry.component.html',
  styleUrls: ['./masonry.component.scss']
})
export class MasonryComponent implements OnInit {

  @Input()
  set dataSource(data: any[]){
    this._data = data
    this.refreshColumns()
  }
  @Input() gutter:string = '0.7rem'
  @ContentChild('masonryItem', {static: false}) masonryItem: TemplateRef<any>;

  @HostListener('window:resize', ['$event']) onResize(event: any) {
    this.refreshColumnsDebounced()
  }

  public columns:number = 3
  private _data:any[]
  public dataColumnFormatted: any[][]

  constructor() { }
  ngOnInit(): void {}

  public dataToColumns(){
    this.dataColumnFormatted = this.arrayToMatrix(this._data, this.columns)
  }

  private refreshColumns(viewPortWidth:number = window.innerWidth){
      this.columns =
        viewPortWidth > 1980
        ? 5
        : viewPortWidth > 1650
        ? 4
        : viewPortWidth > 1400
        ? 3
        : viewPortWidth > 1300
        ? 3
        : viewPortWidth > 992
        ? 2
        : viewPortWidth > 860
        ? 2
        : 1
      this.dataToColumns()
  }
  private refreshColumnsDebounced:any = debounce(this.refreshColumns, 300)


  arrayToMatrix(source:any[], xSize:number=3):any[][] {

    let destination = Array(this.columns)
      .fill([])
      .map(a=>[...a])

    for(let index=0; index<source.length; index+=xSize){
      for(let x=0; x<xSize; x++){
        let framedIndex = index+x
        framedIndex<source.length && destination[x].push(source[framedIndex])
      }
    }

    return destination
  }

}
